export default "__VITE_ASSET__Cecqhq3a__"